export default {
  /**
   * 运营帐号
   */

  getJobList:"/bygRole/findAll",
  getAccountList:"/bygAdmin/findAllAdmins",
  getUnitListForCreate:"/bygApp/findAppInfoAll",
  createOrEditAccount:"/bygAdmin/addOrEdit",
  stopOrReuseAccount:"/bygAdmin/upDownAdmin",
  unbindAcount:"/bygAdmin/unbindingAdmin",
  deleteAccount:"/bygAdmin/del",
  confirmEnterpriseCustomer: "/bygAdmin/confirmEnterpriseCustomer",
}



// WEBPACK FOOTER //
// ./src/api/Operation/urls.js